export default __webpack_public_path__ + "static/media/house-icon.9e29773e.svg";